<template>
	<div class="spinner-container" v-if="processor.loading">
		<SpinnerVue class="spinner" :id="`${uid}_spinner`" :variant="variant" />
	</div>
</template>

<script>
import SpinnerVue from '@/components/visual/spinner/spinner-vue';

export default {
	name: 'Spinner',
	props: {
		processor: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		SpinnerVue
	}
};
</script>

<style lang="scss" scoped>
/**
    * SPINNER CONTAINER
 */
.spinner-container {
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 2000;
	position: relative;
}
</style>
